module.exports = __webpack_public_path__ + "media/images/user/lp/step/ellipse2-8752d63aae0d0636f820527eab5d1408.png";